var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useContext, Fragment } from "react";
import PropTypes from "prop-types";
import { Typography } from "../../Typography";
import { FiAlertCircle, FiCheckCircle } from "react-icons/fi";
import styled, { ThemeContext } from "styled-components";

var MessageIcon = function MessageIcon(_ref) {
  var tone = _ref.tone;

  var theme = useContext(ThemeContext);

  var style = {
    marginRight: "0.5rem",
    position: "relative",
    transform: "translateY(-2px)",
    flexShrink: 0
  };

  switch (tone) {
    case "danger":
      return React.createElement(FiAlertCircle, { style: _extends({ color: theme.dangerMedium }, style) });
    case "warning":
      return React.createElement(FiAlertCircle, { style: _extends({ color: theme.warningMedium }, style) });
    case "success":
      return React.createElement(FiCheckCircle, { style: _extends({ color: theme.successMedium }, style) });
    case "neutral":
      return null;
    default:
      return null;
  }
};

export var FieldMessage = function FieldMessage(_ref2) {
  var message = _ref2.message,
      _ref2$tone = _ref2.tone,
      tone = _ref2$tone === undefined ? "neutral" : _ref2$tone,
      reserveMessageSpace = _ref2.reserveMessageSpace,
      labelSize = _ref2.labelSize;

  if (!reserveMessageSpace && !message) return null;
  return React.createElement(
    Wrapper,
    null,
    message ? React.createElement(
      Fragment,
      null,
      React.createElement(MessageIcon, { tone: tone }),
      React.createElement(
        Typography,
        {
          color: tone + "Medium",
          size: labelSize,
          style: { lineHeight: "1rem" }
        },
        message
      )
    ) : null
  );
};

FieldMessage.displayName = "FieldMessage";

FieldMessage.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

var Wrapper = styled.div.withConfig({
  displayName: "FieldMessage__Wrapper",
  componentId: "sc-10fyok3-0"
})(["display:flex;min-height:1rem;"]);